import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { sendKinesisEvent } from '../analytics/kinesis/actions';

/**
 * StateListenerRegistry provides a reliable way of detecting changes to
 * preferred layout state and dispatching additional actions.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/virtual-background'].selectedThumbnail,
    /* listener */ (selectedThumbnail, { dispatch, getState }, prevSelectedThumbnail) => {
        const { backgroundEffectEnabled, backgroundType } = getState()['features/virtual-background'];
        const data = {};

        if (typeof prevSelectedThumbnail === 'undefined') {
            return;
        }

        if (!backgroundEffectEnabled) {
            data.message = 'background effect disabled';
        } else {
            data.message = 'background effect changed';

            switch (backgroundType) {
            case 'blur':
                data.backgroundType = selectedThumbnail;
                break;
            case 'image':
                data.backgroundType = `${isNaN(Number(selectedThumbnail)) ? 'custom' : 'template'}-image`;
                break;
            default:
                data.backgroundType = backgroundType;
            }
        }

        dispatch(sendKinesisEvent(data));
    }
);
